//
//

import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";

export default {
    name: "ApplicationDetails",
    components: {
        AQBadge
    },
    props: {
        publishStatus: {
            type: String,
            default: "NOT_PUBLISHED"
        },
        modifiedOn: {
            type: String,
            default: ""
        },
        name: {
            type: String,
            default: ""
        },
        owner: {
            type: String,
            default: ""
        },
        type: {
            type: String,
            default: ""
        },
        description: {
            type: String,
            default: ""
        },
        imageUrl: {
            type: String,
            default: ""
        },
        blockchainEnabled: {
            type: Boolean,
            default: false
        },
        blockchainType: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            defaultAvatar: require("@/assets/images/appDefault.svg"),
            appStatus: "unpublished"
        };
    },
    computed: {
        applicationType() {
            let result = this.$t("apps.appTypeNotSet");
            if (this.type === "GF") {
                result = this.$t("apps.blockchainType.standard");
            } else if (this.type === "GFSC") {
                result = this.$t("apps.blockchainType.blockchain");
            }
            return result;
        }
    },
    watch: {
        publishStatus: {
            handler(val) {
                if (val === "NOT_PUBLISHED") {
                    this.appStatus = "unpublished";
                } else if (val === "PUBLISHED") {
                    this.appStatus = "published";
                } else if (val === "UNPUBLISHED_CHANGES") {
                    this.appStatus = "unpublished_changes";
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        formatDate(val) {
            const options = { year: "numeric", month: "2-digit", day: "2-digit" };
            const dateObj = new Date(val);
            let formated = dateObj.toLocaleDateString(undefined, options);
            formated = formated.split("/").join(".");
            return formated;
        }
    }
};
